import { css } from '@emotion/core'

export const form = css`
  text-align: left;
`

export const buttonContainer = css`
  text-align: center;
`

export const resetButton = css`
  width: 50%;
`
